import "core-js/modules/es.regexp.exec.js";
import { useState, useActions } from '@/utils/map-state';
import { computed, ref } from 'vue';
import { updateSpaceProfileAPI } from '@/api';
import { Toast } from 'vant';
export default {
  name: 'NicknameEditPC',
  setup() {
    // state
    const {
      userInfo
    } = useState('user', ['userInfo']);
    const commonActions = useActions('common', ['showNicknameEditPopup']);

    // actions
    const userActions = useActions('user', ['getUserInfo']);

    // public data
    const nickname = ref('');

    // computed
    const freeChangeNickname = computed(() => {
      return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.value.is_change_nickname) <= 0;
    });
    const nicknameValidator = computed(() => {
      const reg = /^[\u4E00-\u9FA5]+$/;
      const maxChar = 8;
      if (nickname.value === '' || nickname.value.length > maxChar) {
        return {
          validate: false,
          errMsg: '请输入2-8位中文字符',
          errCode: 'empty'
        };
      }
      if (!reg.test(nickname.value)) {
        return {
          validate: false,
          errMsg: '请输入2-8位中文字符',
          errCode: 'regFailed'
        };
      }
      return {
        validate: true
      };
    });

    // public methods
    const close = () => {
      commonActions.showNicknameEditPopup({
        'show': false
      });
    };
    const saveSettings = () => {
      if (!nicknameValidator.value.validate) {
        Toast({
          message: nicknameValidator.value.errMsg,
          forbidClick: true
        });
        return;
      }
      let changeFlag = false;
      let params = {
        profilesubmit: true,
        nicknamechanged: userInfo === null || userInfo === void 0 ? void 0 : userInfo.value.is_change_nickname,
        shownicknamenotice: 0,
        profilesubmitbtn: true
      };
      if (nickname.value && nickname.value !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.value.nickname)) {
        params.field1 = nickname.value;
        changeFlag = true;
      }
      if (changeFlag) {
        try {
          updateSpaceProfileAPI(params).then(result => {
            nickname.value = '';
            userActions.getUserInfo({
              showLoading: false
            });
            if (result.head.errCode === '0000') {
              Toast({
                message: '保存成功',
                forbidClick: true,
                onClose: close
              });
            } else {
              Toast({
                message: result.head.errMsg,
                forbidClick: true
              });
            }
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        nickname.value = '';
        Toast({
          message: '保存成功',
          forbidClick: true,
          onClose: close
        });
      }
    };

    // finalReturn
    return {
      userInfo,
      nickname,
      freeChangeNickname,
      close,
      saveSettings
    };
  }
};